import { render, staticRenderFns } from "./settingThemeData.vue?vue&type=template&id=476ea77e&"
import script from "./settingThemeData.vue?vue&type=script&lang=js&"
export * from "./settingThemeData.vue?vue&type=script&lang=js&"
import style0 from "./settingThemeData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports